
export default function leave_admin( state = [], action = {} ){

	switch( action.type ){
		case 'LEAVE_UPLOADED_ATTACHMENT':
			return action.leave_admin
		case 'ADM_GET_USERS':
			return action.leave_admin
		case 'ADM_GET_LEAVE_TYPE':
			return action.leave_admin
		case 'ADM_SAVE_LEAVES':
			return action.leave_admin
		case 'ADM_GET_LEAVE':
			return action.leave_admin
		case 'ADM_DELETE_LEAVE':
			return action.leave_admin
		case 'ADM_SET_LEAVE_TYPE':
			return action.leave_admin
		case 'ADM_SET_LEAVE_DATES':
			return action.leave_admin
		case 'ADM_SET_LEAVE_DOC':
			return action.leave_admin
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/leaves_admin/leaves_admin.reducer.js